/**
 * 原生钱包
 * 目前适用于随手记,其他渠道跳转H5地址
 */
import useragent from '@common/useragent'
import domain from '@common/domain'
import { compare, splice } from './version'
import newView from './newView'

export default () => {
  // h5理财钱包地址
  const h5WalletUrl = `${domain.res}/public-vue/product/index.html#/wallet`
  if (useragent.isSuishouji) {
    const featureVersion = useragent.isAndroid ? '10.2.1.0' : '10.2.8'
    const bugVersion = useragent.isAndroid ? ['10.3.3.0'] : ['10.6.1']
    if (compare(featureVersion) && !splice(bugVersion)) {
      window.location.href = 'feidee://launch.feidee.com/requestGoToUrl/?p=%7b%22type%22%3a%22ActivityNavigation%22%2c%22url%22%3a%2251%22%7d'
    } else if (useragent.isIOS) {
      newView(h5WalletUrl)
    } else {
      window.location.href = h5WalletUrl
    }
  } else {
    newView(h5WalletUrl)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/toWallet.js